<template>
  <div>
    <div v-if="!isReady && !initError" class="c-loading-wrapper">
      <search-loading />
    </div>
    <school-districts-list v-else-if="isReady && !initError" :propertyPrefList="propertyPrefList" :preflist="preflist" :schoolList="schoolList" :schoolFlag="schoolFlag" :selectedSchoolId="selectedSchoolId" :contains-hits="containsHits"/>
    <error-modal :modal="initError" @close="returnToTop"/>
  </div>
</template>

<script>
import SchoolDistrictsList from '@/components/search/school-districts/SchoolDistrictsList';
import MixinAPI from '@/plugins/mixin-api';
import SearchLoading from '@/components/search/kodate/SearchLoading';
import ErrorModal from '@/components/common/ErrorModal';

export default {
  name: 'SearchSchoolDistricts',
  components: {
    SearchLoading,
    SchoolDistrictsList,
    ErrorModal,
  },
  mixins: [MixinAPI],
  data() {
    return {
      isReady: false,
      preflist: null,
      propertyPrefList: null,
      schoolList: [],
      schoolFlag: '小学校',
      selectedSchoolName: null,
      containsHits: false,
      initError: false,
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.fullPath': function () {
      this.isReady = false;
      this.preflist = null;
      this.schoolList = [];
      this.schoolFlag = '小学校';
      this.selectedSchoolName = null;
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    returnToTop() {
      this.$router.push('/');
    },
    async initialize() {
      // fetch school data, potentially do something with favorites
      // Double check SearchKodate component
      const prefCode = this.$route.params.prefecture;
      const cityName = this.$route.params.city;
      const id = +this.$route.query.id;
      this.schoolFlag = this.$route.query.type;

      this.preflist = await this.getPrefectureList();
      this.propertyPrefList = await this.getPrefectureList(1, 0);
      const prefecture = this.preflist.find(p => p.pref_code.toString() === prefCode.toString());
      if (!prefecture) {
        this.$router.push('/');
      }

      this.cityList = await this.getCityList(0, prefCode);
      const cityListWithHits = await this.getCityList(1, prefCode, 0);

      const city = this.cityList.find(c => cityName.includes(c.city_name));

      if (!city) {
        this.initError = true;
        return;
      }

      // Do we have properties to show for this particular city?
      if (city) {
        this.containsHits = !!cityListWithHits.find(c => city.city_code === c.city_code);
      }

      const locationObject = {
        type: 0,
        area: {
          id: prefecture.area_id,
          code: prefecture.area_code,
          name: prefecture.area_name,
        },
        pref: {
          id: prefecture.pref_id,
          code: prefecture.pref_code,
          name: prefecture.pref_name,
        },
        city: {
          id: city ? city.city_id : null,
          code: city ? city.city_code : null,
          name: city ? city.city_name : cityName,
        },
        station: {
          id: null,
          code: null,
          name: null,
        },
      };
      this.$store.commit('setLocation', locationObject);

      if (this.schoolFlag === '小学校') {
        this.schoolList = await this.getElementarySchools('', prefecture.pref_name, cityName);
      } else {
        this.schoolList = await this.getJuniorHighSchools('', prefecture.pref_name, cityName);
      }
      if (!this.schoolList || this.schoolList.length === 0) {
        this.initError = true;
        return;
      }
      this.selectedSchoolId = id;
      this.isReady = true;
    },

  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.c-loading-wrapper {
  height: 800px;
  display: flex;
  align-items: center;
}
</style>
